export enum TopicName {
    UserToAircraftCommand = "UserToAircraftCommand",
    UserStatus = "UserStatus",
    InterPilot = "InterPilot",
    PilotLog = "PilotLog",
    AirText = "AirText",
    PluginCommand = "PluginCommand",
}